export class RunningGameHandler {
    constructor(private _gameOptions: any) {

    }

    closeGame() {
        if(this._gameOptions.gameWindow) {
            this._gameOptions.gameWindow.closeGameWindow();
        }
    }
}